import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useApp } from "../../../contexts/AppContext";

export default function HeroSection() {
  const [visible, setVisible] = useState(false);
  const { isLoggedIn, setMode } = useApp();
  const navigate = useNavigate();

  useEffect(() => { setTimeout(() => setVisible(true), 100); }, []);

  const handleSell = () => {
    if (isLoggedIn) {
      setMode("provider");
      navigate("/mypage/provider");
    } else {
      navigate("/register");
    }
  };

  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {/* Abstract art background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/7c3d859ab9a3e9cfeb9fd534bc8ce178.jpg"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-deep-green/65 via-deep-green/45 to-deep-green/75" />
        <div className="absolute inset-0 bg-gradient-to-r from-deep-green/25 via-transparent to-deep-green/25" />
      </div>

      {/* Centered content */}
      <div className="relative w-full flex flex-col items-center justify-center px-4 pt-28 pb-20 text-center">
        <p
          className={`font-display italic text-gold text-xs md:text-sm tracking-[0.35em] mb-8 transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}
          style={{ transitionDelay: "0.1s" }}
        >
          Artisan Knowledge Platform
        </p>

        <h1
          className={`font-serif leading-tight mb-6 transition-all duration-1000 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
          style={{ transitionDelay: "0.25s" }}
        >
          <span className="block text-white text-5xl md:text-7xl lg:text-8xl font-extralight tracking-wide">職人の技を、</span>
          <span className="block text-ivory text-5xl md:text-7xl lg:text-8xl font-extralight italic font-display mt-2">あなたの手に。</span>
          <span className="block text-gold text-2xl md:text-3xl lg:text-4xl font-light tracking-[0.2em] mt-5">ツギテで学ぶ。</span>
        </h1>

        <div
          className={`flex items-center justify-center gap-4 mb-8 transition-all duration-700 ${visible ? "opacity-100" : "opacity-0"}`}
          style={{ transitionDelay: "0.45s" }}
        >
          <div className="w-20 h-px bg-gold/40" />
          <div className="w-1.5 h-1.5 rounded-full bg-gold/60" />
          <div className="w-20 h-px bg-gold/40" />
        </div>

        <p
          className={`text-white/70 text-sm md:text-base font-sans font-light leading-relaxed mb-10 max-w-lg transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
          style={{ transitionDelay: "0.5s" }}
        >
          あらゆるサービス業の卓越した技術を、事業者から直接学べる教育ECモール。<br className="hidden md:block" />
          動画講座・教材キット・購入後のメッセージで、本物の技が身につきます。
        </p>

        <div
          className={`flex flex-col sm:flex-row gap-4 justify-center transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
          style={{ transitionDelay: "0.65s" }}
        >
          <Link to="/providers" className="bg-white text-deep-green px-10 py-4 rounded-full font-sans font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-ivory transition-all duration-300 hover:-translate-y-1 text-center">
            事業者を探す →
          </Link>
          <button
            onClick={handleSell}
            className="border border-white/70 text-white px-10 py-4 rounded-full font-sans font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-white hover:text-deep-green transition-all duration-300 hover:-translate-y-1 text-center"
          >
            無料で出店する →
          </button>
        </div>

        <div
          className={`mt-16 flex items-center justify-center gap-8 sm:gap-16 transition-all duration-700 ${visible ? "opacity-100" : "opacity-0"}`}
          style={{ transitionDelay: "0.85s" }}
        >
          {[
            { num: "120+", label: "登録事業者", icon: "ri-store-2-line" },
            { num: "480+", label: "講座・教材", icon: "ri-play-circle-line" },
            { num: "4.8", label: "平均評価", icon: "ri-star-line" },
            { num: "30+", label: "専門カテゴリ", icon: "ri-grid-line" },
          ].map((s) => (
            <div key={s.label} className="flex flex-col items-center gap-1">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className={`${s.icon} text-gold/60 text-lg`} />
              </div>
              <p className="font-display text-2xl md:text-3xl text-white font-light">{s.num}</p>
              <p className="text-white/40 text-xs font-sans tracking-wide">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
        <p className="text-white/30 text-xs font-sans tracking-[0.25em]">SCROLL</p>
        <div className="w-px h-10 bg-gradient-to-b from-white/30 to-transparent scroll-indicator" />
      </div>
    </section>
  );
}
